/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates strings
import classnames from "classnames";
// reactstrap components
import {
  Button,
  Collapse,
  Navbar,
  NavItem,
  Nav,
  Container,
} from "reactstrap";

function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 300 ||
        document.body.scrollTop < 300
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <Navbar className={classnames("fixed-top", navbarColor)} expand="lg">
      <Container>
        <div className="navbar-translate">
            <Button
              className="btn-round"
              color="success"
              href="/index"
            >
              Home
            </Button>
          <button
            aria-expanded={navbarCollapse}
            className={classnames("navbar-toggler navbar-toggler", {
              toggled: navbarCollapse,
            })}
            onClick={toggleNavbarCollapse}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>
        <Collapse
          className="justify-content-end"
          navbar
          isOpen={navbarCollapse}
        >
          <Nav navbar>
          <NavItem>
            <Button
              className="btn-round"
              color="info"
              href="/about"
            >
              <i className="fa fa-info"></i> About Us
            </Button>
          </NavItem>
          <NavItem>
            <Button
              className="btn-round"
              color="success"
              href="/educational-programs"
            >
              <i className="fa fa-graduation-cap"></i> Educational Programs
            </Button>
          </NavItem>
          <NavItem>
            <Button
              className="btn-round"
              color="primary"
              href="/educational-solutions"
            >
              <i className="fa fa-lightbulb-o"></i> Solutions
            </Button>
          </NavItem>
          {/* Temporarily hidden - Knowledge Base nav item
          <NavItem>
            <Button
              className="btn-round"
              color="default"
              href="/knowledge-base"
            >
              <i className="fa fa-book"></i> Knowledge Base
            </Button>
          </NavItem>
          */}
          <NavItem>
            <Button
              className="btn-round"
              color="warning"
              href="https://archery.robotyze.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-crosshairs"></i> Archery
            </Button>
          </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default IndexNavbar;
